import {
  EDIT_RELAY_SCHEDULE,
  MATCH_RELAY_SCHEDULE_OFFSETS,
  RECEIVE_RELAY_SCHEDULES,
  REQUEST_SITE_RELAY_SCHEDULES,
} from '@sophocles/entities/RelaySchedule/relayScheduleActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAY_SCHEDULES:
      return action.relaySchedules;
    case MATCH_RELAY_SCHEDULE_OFFSETS:
      const schedules = state.filter(schedule => action.relays.contains(schedule.get('relay', '0')));
      return schedules.map(schedule =>
        schedule.set('sunset_offset', action.sunsetOffset).set('sunrise_offset', action.sunriseOffset),
      );
    case REQUEST_SITE_RELAY_SCHEDULES:
    case EDIT_RELAY_SCHEDULE:
    default:
      return state;
  }
}

export function relayScheduleReducer(state = Map(), action) {
  switch (action.type) {
    case REQUEST_SITE_RELAY_SCHEDULES:
    case RECEIVE_RELAY_SCHEDULES:
    case EDIT_RELAY_SCHEDULE:
    case MATCH_RELAY_SCHEDULE_OFFSETS:
      return state.merge(getState(state, action));
    default:
      return state;
  }
}
